import React, { useEffect } from "react";
import "./../../../HomePage/Faq/Faq.css";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
const FaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is UAE Embassy Attestation and why do I need it?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              UAE Embassy Attestation is the official process of validating your
              documents—such as degree certificates, marriage certificates,
              birth certificates, or commercial papers—so they are legally
              accepted by UAE authorities for jobs, visas, studies, or residence
              purposes. Without attestation, your documents will not be
              recognized in the UAE.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does UAE Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Processing time varies based on document type. Common timeline:
              <ul>
                <li>
                  {" "}
                  <b>Educational Certificates:</b> 3–7 working days
                </li>
                <li>
                  <b>Personal Certificates (Birth/Marriage):</b> 5–10 working
                  days
                </li>
                <li>
                  <b>Commercial Documents:</b> 7–12 working days Many agencies
                  offer Express 5-Day Service for faster processing.
                </li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents are required for UAE Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Typically, you need:
              <ul>
                <li>Original certificate</li>
                <li> Passport copy</li>
                <li> Visa copy (if applicable)</li>
                <li> Authorization letter (if using an agency)</li>
                <li>
                  Marksheet copies (for degree attestation) Requirements may
                  vary depending on the UAE Department.
                </li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to hand over my original certificates?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—if you choose a Govt-approved, ISO-certified attestation
              agency. Trusted agencies provide:
              <ul>
                <li> Acknowledgment receipts</li>
                <li> Transparent tracking</li>
                <li> Sealed handover</li>
                <li>
                  Full chain-of-custody security Never give documents to
                  freelancers or unverified agents.
                </li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                {" "}
                Can I get UAE Attestation done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many trusted agencies in Bangalore provide:
              <ul>
                <li> Free Home Pickup & Drop</li>
                <li> Doorstep Document Collection</li>
                <li>
                  Online Tracking This is especially useful for working
                  professionals and people living far from city centers.
                </li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does UAE Attestation cost in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Fees depend on document type and processing speed. Approximate
              ranges:
              <ul>
                <li> Degree Attestation: ₹4,500–₹12,000</li>
                <li> Marriage/Birth Certificate: ₹5,500–₹13,000</li>
                <li>
                  Commercial Documents: ₹12,000–₹25,000 Always compare prices
                  and look for hidden charges.
                </li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps involved in UAE Attestation? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              A proper agency will handle the full chain:
              <ul>
                <li> 1. Home Pick-Up</li>
                <li>2. Notary Attestation</li>
                <li>3. HRD/SDM/State Attestation</li>
                <li>
                  4. MEA Attestation (Ministry of External Affairs – India)
                </li>
                <li>5. UAE Embassy Attestation</li>
                <li>6. MOFA Attestation (in the UAE, if required)</li>
              </ul>
              You will receive regular updates throughout the process.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Is MOFA Attestation (in UAE) required after embassy attestation?{" "}
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—MOFA (Ministry of Foreign Affairs UAE) attestation is needed
              for:
              <ul>
                <li> Employment visas</li>
                <li> Family visas</li>
                <li> Business setup</li>
                <li>Higher studies</li>
              </ul>
              Some agencies also help with MOFA Assistance through UAE partners.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How do I check if an attestation agency is genuine?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Choose an agency that is:
              <ul>
                <li> Govt Approved</li>
                <li> ISO Certified</li>
                <li> Has 25000+ documents processed</li>
                <li> Works with 30+ MNCs</li>
                <li> Provides physical office in Bangalore</li>
                <li> Offers tracking + invoices + receipts</li>
              </ul>
              Avoid WhatsApp-only agents with no office.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can UAE Attestation be done urgently?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Most reputed agencies offer Express Attestation:{" "}
              <ul>
                <li> Delivery within 3–5 working days</li>
                <li> Priority processing</li>
                <li> Additional charges may apply</li>
              </ul>
              This is ideal when your employer or immigration consultant gives
              short deadlines.{" "}
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default FaqMain;
